import { ACTION_TYPES } from 'store/ActionTypes';
import { IfSvrConf, SvrConf } from 'models/IfSvrConf';
import { LoginInfo } from 'models/IfLoginInfo';
import { IfReduxMainState } from 'store/reducers/redux-model';
import { DisplayPopupItem, IfDisplayPopupItem } from 'models/IfDisplayPopupItem';
import { useDispatch, useSelector } from 'react-redux';
import React from 'react';

const initState: IfReduxMainState = {
  svrConf: new SvrConf(),
  loginInfo: new LoginInfo(),
  loading: false,
  displayPopupItem: new DisplayPopupItem(),
  displayBottomPopup: false,
};

const reducerMain = (state = initState, action) => {
  switch (action.type) {
    case ACTION_TYPES.MAIN.SVR_CONF:
      return { ...state, svrConf: { ...action.payload } };
    case ACTION_TYPES.MAIN.LOGIN_INFO:
      return { ...state, loginInfo: { ...action.payload } };
    case ACTION_TYPES.MAIN.LOADING:
      return { ...state, loading: action.payload };
    case ACTION_TYPES.MAIN.DISPLAY_POPUP_ITEM:
      return { ...state, displayPopupItem: { ...action.payload } };
    case ACTION_TYPES.MAIN.DISPLAY_BOTTOM_POPUP:
      return { ...state, displayBottomPopup: action.payload };
    default:
      return state;
  }
};

export default reducerMain;

export const useSvrInfo = (): { svrConf: IfSvrConf } => {
  const svrConf = useSelector((state: any) => state.main.svrConf as IfSvrConf);
  return { svrConf };
};
